import { render, staticRenderFns } from "./SoldAssetTable.vue?vue&type=template&id=e9981742&scoped=true&"
import script from "./SoldAssetTable.vue?vue&type=script&lang=js&"
export * from "./SoldAssetTable.vue?vue&type=script&lang=js&"
import style0 from "./SoldAssetTable.vue?vue&type=style&index=0&id=e9981742&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9981742",
  null
  
)

export default component.exports